// extracted by mini-css-extract-plugin
export default {"p":"AboutVersion_p__udi5r","historyLink":"AboutVersion_historyLink__rbSIT","placeHolderShimmer":"AboutVersion_placeHolderShimmer__oqkC-"};